import {Component, OnInit} from '@angular/core';
// import { FormsModule, FormControl } from '@angular/forms';
import {Router} from '@angular/router';
// import { AuthService } from '../../shared/auth/auth.service';
import {CognitoAuthService, CognitoCallback} from '../../shared/auth/cognito.service';

declare let AWS: any;
declare let AWSCognito: any;

@Component({
    selector: 'app-sign-in',
    templateUrl: './sign-in.component.html',
    styleUrls: ['./sign-in.component.css'],
    providers: [CognitoAuthService]
})
export class SignInComponent implements CognitoCallback, OnInit {

    email: string = '';
    password: string = '';
    errorMessage: string = '';
    requiredFieldsErrorMessage: string = 'All fields are required';
    signInErrorMessage: string = 'Email or password is incorrect';

    constructor(public router: Router, public userService: CognitoAuthService) {

        // console.log("SignInComponent constructor");
    }

    ngOnInit() {
        const self = this;
        this.errorMessage = null;
        // check if user is authenticated, then redirect to dashboard if so
        // console.log("Checking if user is authenticated, redirect to dashboard if so");

        this.userService.isAuthenticated({
            isLoggedIn: function(message, loggedIn) {

                // console.log('isLoggedIn() called by isAuthenticated()');
                if (loggedIn) {
                    self.router.navigate(['/dashboard']);
                }
            }
        });
    }

    signIn() {
        this.email = this.email.toLowerCase();
        if (this.email == null || this.password == null) {
            this.errorMessage = this.requiredFieldsErrorMessage;
            return;
        }

        this.errorMessage = null;
        // console.log("begin authenticate");

        this.userService.authenticate(this.email, this.password, this);
        // console.log("end authenticate");
    }

    cognitoCallback(message: string, result: any): void {

        if (message != null) {
            // this.errorMessage = message;
            this.errorMessage = this.signInErrorMessage;
            // console.log("result: " + this.errorMessage);
        } else {
            // console.log('Successfully signed in using Cognito User Pools');
            this.router.navigate(['', 'dashboard']);
        }
    }
}



// WEBPACK FOOTER //
// /app/src/app/containers/sign-in/sign-in.component.ts